var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"onHover",staticStyle:{"margin":"0"},attrs:{"color":_vm.colors,"right":"","small":"","title":"Мой комментарий"}},[_vm._v("comment")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }